// hooks/useUsiPopup.js
import { useState, useEffect, useCallback } from "react";
import Axios from "axios";
import * as constants from "../constants";

export const useUsiPopup = (studentId) => {
  const [showPopup, setShowPopup] = useState(false);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const checkUsiPopup = useCallback(async () => {
    if (!studentId) return;

    setIsLoading(true);
    try {
      const response = await Axios.get(`${constants.BASEURL}Student/${studentId}/usipopup`);

      const { shouldShowPopup, popupMessage } = response.data;

      if (shouldShowPopup) {
        setShowPopup(true);
        setMessage(popupMessage);
      }
    } catch (error) {
      console.error("Error checking USI popup:", error);
    } finally {
      setIsLoading(false);
    }
  }, [studentId]);

  const handleLater = useCallback(async(hideForWeek = false) => {
    if(hideForWeek) {
      try {
        await Axios.post(`${constants.BASEURL}Student/hideUsiPop`, null, {
          params: {
            studentId: studentId
          }
        });
        setShowPopup(false);
      } catch (error) {
        console.error("Error hiding USI popup:", error);
      }
    } else {
      setShowPopup(false);
    }
    // setShowPopup(false);
  }, [studentId]);

  useEffect(() => {
    checkUsiPopup();    
  }, [checkUsiPopup]);

  return {
    showPopup,
    message,
    isLoading,
    handleLater,
    checkUsiPopup,
  };
};